import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, Typography } from '@mui/material';
/**
 * This component will truncate text depending on the settings passed by props.
 */
export var Truncate = function (_a) {
    var children = _a.children, lineCamp = _a.lineCamp, tooltip = _a.tooltip;
    return (_jsx(Tooltip, __assign({ title: tooltip && typeof children === 'string' ? children : undefined }, { children: _jsx(Typography, __assign({ component: "span", sx: {
                lineHeight: '2rem',
                display: '-webkit-box',
                overflow: 'hidden !important',
                textOverflow: 'ellipsis',
                WebkitLineClamp: lineCamp,
                WebkitBoxOrient: 'vertical',
            } }, { children: children })) })));
};
